import axios from '../internal/axios';
export var verify = function verify(_ref) {
  var user_id = _ref.user_id,
      signature = _ref.signature,
      key = _ref.key,
      expire = _ref.expire,
      additional = _ref.additional;
  return axios.post("/user/".concat(user_id, "/verify"), {
    signature: signature,
    key: key,
    expire: expire,
    additional: additional
  }).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result;
    } else {
      throw Error(result.status);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};